import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import { useControl, useControlReducer } from "../../../controlContext";
import { useSource } from "../../../sourceContext";

export function MultiPicker({ idx, name, label }) {
  const controls = useControl()
  const controlReducer = useControlReducer()
  const source = useSource()
  const value = useMemo(()=>controls[idx][name] || [], [controls, name, idx])
  const menuOptions = useMemo(() => {
    return source[name].map((itm, i) => (<option key={i} value={itm._id}>{itm.name}</option>))
  }, [source, name])

  function onChange(evt) {
    const newVal = [...evt.target.selectedOptions].map(opt=>opt.value)
    console.log('multipicker onChange', newVal)
    controlReducer({ idx, name, type: 'changed', update: {[name]: newVal } })
  }

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <Form.Control className="lang-editor-multiselect" idx={idx} as="select" multiple value={value} onChange={onChange}>
        {menuOptions}
      </Form.Control>
    </Form.Group>
  )
}